import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  getLoyaltyTiers,
  selectLoyaltyTiers,
} from '../../../../store/LoyaltyTierReducer'
import { LoyaltyTierCard } from './LoyaltyTierCard'

interface Props {
  viewOnly: boolean
}

export const LoyaltyTierList = ({ viewOnly }: Props) => {
  const dispatch = useAppDispatch()
  const loyaltyTiers = useAppSelector(selectLoyaltyTiers())

  useEffect(() => {
    dispatch(getLoyaltyTiers(initialQuery))
  }, [dispatch])

  return (
    <>
      {loyaltyTiers.map((loyaltyTier) => (
        <LoyaltyTierCard
          key={loyaltyTier.id}
          loyaltyTier={loyaltyTier}
          viewOnly={viewOnly}
        />
      ))}
    </>
  )
}
